import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=1267ef1a&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=1267ef1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267ef1a",
  null
  
)

export default component.exports